import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=9c44be7c&scoped=true"
import script from "./Loading.ts?vue&type=script&lang=ts&external"
export * from "./Loading.ts?vue&type=script&lang=ts&external"
import style0 from "./Loading.vue?vue&type=style&index=0&id=9c44be7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c44be7c",
  null
  
)

export default component.exports